export default "__VITE_ASSET__00649cb5__"